import React from 'react';
import PageWrap, { Title } from "./Page.styled";

const About = () => <PageWrap><Title>noodled is a <span>puzzle game</span></Title></PageWrap>;

export default About;


// WEBPACK FOOTER //
// ./src/components/pages/Page/Page.js